/**
 * API client generated from the OpenAPI schema (ADR 0003 rule 3): no hand-written request
 * types. Same-origin cookie session; the CSRF token from /me is sent on unsafe methods.
 * Errors arrive as codes (ADR 0017 rule 7) and are rendered from the `error` namespace.
 */
import createClient, { type Middleware } from "openapi-fetch";

import type { paths } from "./api-types";

let csrfToken: string | null = null;
export function setCsrfToken(token: string | null): void {
  csrfToken = token;
}
export function getCsrfToken(): string | null {
  return csrfToken;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    public readonly details: Record<string, unknown> = {},
  ) {
    super(code);
  }
}

const csrf: Middleware = {
  onRequest({ request }) {
    if (!["GET", "HEAD", "OPTIONS"].includes(request.method) && csrfToken) {
      request.headers.set("x-csrf-token", csrfToken);
    }
    return request;
  },
};

export const api = createClient<paths>({ baseUrl: "", credentials: "same-origin" });
api.use(csrf);

/** Unwrap an openapi-fetch result, turning the error envelope into ApiError. */
export async function call<T>(
  p: Promise<{ data?: T; error?: unknown; response: Response }>,
): Promise<T> {
  let res;
  try {
    res = await p;
  } catch {
    throw new ApiError(0, "NETWORK");
  }
  if (res.error !== undefined || !res.response.ok) {
    const body = res.error as { error?: { code?: string; details?: Record<string, unknown> } };
    throw new ApiError(res.response.status, body?.error?.code ?? "unknown", body?.error?.details);
  }
  return res.data as T;
}

export function loginUrl(returnTo: string): string {
  return `/app/v1/auth/login?return_to=${encodeURIComponent(returnTo)}`;
}
